import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgStatus = (props) => /* @__PURE__ */ _jsx("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	textAnchor: "middle",
	width: 15,
	height: 15,
	viewBox: "0 0 15 15",
	...props,
	children: /* @__PURE__ */ _jsxs("g", {
		fill: "none",
		fillRule: "evenodd",
		children: [/* @__PURE__ */ _jsx("circle", {
			cx: 7.5,
			cy: 7.5,
			r: 7,
			fill: "currentColor"
		}), /* @__PURE__ */ _jsx("text", {
			fill: "#FFF",
			fontFamily: "Helvetica-Bold, Helvetica",
			fontSize: 12,
			fontWeight: "bold",
			children: /* @__PURE__ */ _jsx("tspan", {
				x: 7.502,
				y: 12,
				children: "!"
			})
		})]
	})
});
export default SvgStatus;
